import { render, staticRenderFns } from "./hogcfd.vue?vue&type=template&id=15a89816&scoped=true&"
import script from "./hogcfd.vue?vue&type=script&lang=js&"
export * from "./hogcfd.vue?vue&type=script&lang=js&"
import style0 from "./hogcfd.vue?vue&type=style&index=0&id=15a89816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a89816",
  null
  
)

export default component.exports